
import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ThreePillars from '../components/ThreePillars';
import WhySparkwaveAI from '../components/WhySparkwaveAI';
import HowItWorks from '../components/HowItWorks';
import AIApps from '../components/AIApps';
import BetaProgramCTA from '../components/BetaProgramCTA';
import PersonaAI from '../components/PersonaAI';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';

const Index: React.FC = () => {
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Set document title and description for SEO
    document.title = "Sparkwave AI - Cutting-edge AI Solutions";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Empowering businesses with cutting-edge AI solutions that drive growth and efficiency.');
    }
    
    // Update Open Graph tags
    const updateMetaTag = (selector: string, attribute: string, value: string) => {
      const tag = document.querySelector(selector);
      if (tag) {
        tag.setAttribute(attribute, value);
      }
    };
    
    // Update site name to ensure no Lovable branding remains
    updateMetaTag('meta[property="og:site_name"]', 'content', 'Sparkwave AI');
    updateMetaTag('meta[property="og:title"]', 'content', 'Sparkwave AI - Cutting-edge AI Solutions');
    updateMetaTag('meta[property="linkedin:title"]', 'content', 'Sparkwave AI - Cutting-edge AI Solutions');
    updateMetaTag('meta[property="telegram:title"]', 'content', 'Sparkwave AI - Cutting-edge AI Solutions');
    updateMetaTag('meta[property="twitter:title"]', 'content', 'Sparkwave AI - Cutting-edge AI Solutions');
    
    // Update image URLs to ensure they're absolute
    const baseUrl = window.location.origin;
    updateMetaTag('meta[property="og:image"]', 'content', `${baseUrl}/lovable-uploads/2a4ca809-1e4b-4f11-9936-d9e370f05626.png`);
    updateMetaTag('meta[property="twitter:image"]', 'content', `${baseUrl}/lovable-uploads/2a4ca809-1e4b-4f11-9936-d9e370f05626.png`);
    updateMetaTag('meta[property="linkedin:image"]', 'content', `${baseUrl}/lovable-uploads/2a4ca809-1e4b-4f11-9936-d9e370f05626.png`);
    updateMetaTag('meta[property="telegram:image"]', 'content', `${baseUrl}/lovable-uploads/2a4ca809-1e4b-4f11-9936-d9e370f05626.png`);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="flex flex-col w-full">
        <Hero />
        <ThreePillars />
        <PersonaAI />
        <WhySparkwaveAI />
        <HowItWorks />
        <AIApps />
        <BetaProgramCTA />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
